import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ContactInfo } from './contact/ContactInfo';
import { navigateToStartHere } from '../utils/navigation';

export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <footer className="relative border-t border-blue-500/20">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/95 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="backdrop-blur-sm p-6 rounded-lg border border-blue-500/20">
            <h3 className="text-lg font-bold text-white mb-4">Contact</h3>
            <ContactInfo />
          </div>

          <div className="backdrop-blur-sm p-6 rounded-lg border border-blue-500/20">
            <h3 className="text-lg font-bold text-white mb-4">Quick Links</h3>
            <div className="grid grid-cols-2 gap-3 text-gray-400">
              <div><Link to="/" className="hover:text-blue-500 transition-colors">Home</Link></div>
              <div><Link to="/marketing" className="hover:text-blue-500 transition-colors">Social Media Marketing</Link></div>
              <div><Link to="/automation" className="hover:text-blue-500 transition-colors">Lead Rescue & Automation</Link></div>
              <div><Link to="/other-services" className="hover:text-blue-500 transition-colors">Other Services</Link></div>
              <div>
                <button
                  onClick={() => navigateToStartHere(navigate, location.pathname)}
                  className="hover:text-blue-500 transition-colors text-left"
                >
                  Start Here
                </button>
              </div>
              <div><Link to="/privacy-policy" className="hover:text-blue-500 transition-colors">Privacy Policy</Link></div>
              <div><Link to="/terms-of-service" className="hover:text-blue-500 transition-colors">Terms of Service</Link></div>
              <div><Link to="/refund-policy" className="hover:text-blue-500 transition-colors">Refund Policy</Link></div>
            </div>
          </div>

          <div className="backdrop-blur-sm p-6 rounded-lg border border-blue-500/20">
            <h3 className="text-lg font-bold text-white mb-4">Operating Hours</h3>
            <div className="space-y-2 text-gray-400">
              <p>9a-5p every day</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-blue-500/20 text-center text-gray-500">
          <p>&copy; {new Date().getFullYear()} Priority AI Services. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}